import React, { useState, useEffect, useCallback } from "react";
import "./../../../assets/css/purchase/form.css";

// Components
import Breadcrumbs from "../../components/Breadcrumbs";
import Sidebar from "../../components/Sidebar";
import ReportsTable from "../../components/Content/ReportsTable";

// Utils
import { getAlert, getDataByQuery, getDataWithJoin } from "../../../utils/SamuiUtils";

const OverdueLoanCrateReport = () => {
    // ตัวแปรเก็บชื่อหน้าจอ
    const [name, setName] = useState(null);

    // ข้อมูลที่แสดงรายงาน
    const [filteredData, setFilteredData] = useState([]);

    // สำหรับ Table รายงาน
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(16);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);
    const [exportController, setExportController] = useState({
        exportToExcel: null,
        isExporting: false,
        hasData: false,
    });

    useEffect(() => {
        initialize();
    }, []);

    const initialize = async () => {
        // เริ่มต้นหน้าจอ (เปิดครั้งแรก)
        setName("5. รายงานลูกค้ายืมลัง แล้วไม่สั่งเกินสัปดาห์");
        setFilteredData([]);
    };

    const handleSearch = async () => {
        try {
            setFilteredData([]);

            let query = `
                -- STEP 1: ดึงข้อมูลสินค้าแต่ละใบ พร้อมชื่อ และวันที่ขายล่าสุดของสินค้าแต่ละรายการ
                WITH ItemDetails AS (
                SELECT 
                    wdh.WHDoc_Cust_Code,
                    wdh.WHDoc_Cust_Name,
                    FORMAT(CAST(MAX(soh.Doc_Date) AS DATETIME), 'dd/MM/yyyy') AS Last_Sale_Date,
                    wdd.Item_Name
                FROM API_1001_WHDOC_H wdh
                INNER JOIN API_1002_WHDOC_D wdd 
                    ON wdd.WHDoc_Id = wdh.WHDoc_Id AND wdd.Item_Is_Return = 0
                INNER JOIN SO_H soh 
                    ON soh.AR_ID = wdh.WHDoc_Cust_Id
                WHERE wdh.WHDoc_Type = 6
                    AND wdh.Comp_Id = 2
                    AND NOT EXISTS (
                    SELECT 1 
                    FROM SO_H soh2
                    WHERE soh2.AR_ID = wdh.WHDoc_Cust_Id
                        AND soh2.Comp_Id = wdh.Comp_Id
                        AND soh2.Doc_Date >= CAST(GETDATE() - 7 AS DATE)
                    )
                GROUP BY wdh.WHDoc_Cust_Code, wdh.WHDoc_Cust_Name, wdd.Item_Name
                )

                -- STEP 2: รวมข้อมูลตามลูกค้า
                SELECT 
                i1.WHDoc_Cust_Code,
                i1.WHDoc_Cust_Name,
                MAX(i1.Last_Sale_Date) AS Last_Sale_Date,
                COUNT(*) AS Item_Count,
                STUFF((
                    SELECT ',' + i2.Item_Name
                    FROM ItemDetails i2
                    WHERE i2.WHDoc_Cust_Code = i1.WHDoc_Cust_Code
                    FOR XML PATH(''), TYPE).value('.', 'NVARCHAR(MAX)'), 1, 1, '') AS Item_List
                FROM ItemDetails i1
                GROUP BY i1.WHDoc_Cust_Code, i1.WHDoc_Cust_Name
                ORDER BY i1.WHDoc_Cust_Code
            `;

            const response = await getDataByQuery(
                query
            );

            if (response && response.length > 0) {
                setFilteredData(response);
            }
        } catch (error) {
            getAlert("FAILED", error.response?.message || error.message);
        }
    };

    const handleExportReady = useCallback((state) => {
        setExportController((prev) => {
            if (
                prev.exportToExcel === state.exportToExcel &&
                prev.isExporting === state.isExporting &&
                prev.hasData === state.hasData
            ) {
                return prev;
            }
            return state;
        });
    }, []);

    const handleExportClick = useCallback(() => {
        if (exportController?.exportToExcel) {
            exportController.exportToExcel();
        } else {
            getAlert("FAILED", "ไม่มีข้อมูลสำหรับ Export");
        }
    }, [exportController]);

    return (
        <>
            <Sidebar />
            <div className="main-panel">
                <div className="container">
                    <div className="page-inner">
                        <div className="page-header d-flex justify-content-between align-items-center">
                            <Breadcrumbs
                                page={name}
                                items={[
                                    { name: "รายงาน", url: "/reports" },
                                    { name: name, url: "/overdue-loan-crate-report" },
                                ]}
                            />
                        </div>
                        <div className="row">
                            {/* Criteria */}
                            <div className="col-md-12">
                                <div className="card">
                                    <div className="card-header">
                                        <h4>เงื่อนไขการค้นหา</h4>
                                    </div>
                                    <div className="card-body">
                                        <form className="row g-3">
                                            <div className="col-md-12 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', marginRight: '20px', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => handleSearch()}
                                                >
                                                    <i className="fas fa-search" /> ค้นหา
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', marginRight: '20px', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={handleExportClick}
                                                    disabled={!exportController.hasData || exportController.isExporting}
                                                >
                                                    <i className="fas fa-file-excel" />{" "}
                                                    {exportController.isExporting ? 'กำลังส่งออก...' : 'Export'}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-lg shadow text-white"
                                                    style={{ width: '10%', backgroundColor: '#EF6C00', fontSize: '16px' }}
                                                    onClick={() => initialize()}
                                                >
                                                    <i className="fas fa-undo" /> เริ่มใหม่
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            {/* ReportsTable */}
                            <ReportsTable
                                currentItems={currentItems}
                                currentPage={currentPage}
                                handlePageChange={(pageNumber) => setCurrentPage(pageNumber)}
                                setCurrentPage={setCurrentPage}
                                setItemsPerPage={setItemsPerPage}
                                dataMasterList={filteredData}
                                itemsPerPage={itemsPerPage}
                                fieldMappings={{
                                    arCode: 'WHDoc_Cust_Code',
                                    arName: 'WHDoc_Cust_Name',
                                    lastDate: 'Last_Sale_Date',
                                    amount: 'Item_Count',
                                    ibNo: 'Item_List'
                                }}
                                onExportReady={handleExportReady}
                                showExportButton={false}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
};

export default OverdueLoanCrateReport;
